import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAnnouncementStore } from '@stores/announcementStore';

const BANNER_DISMISSED_KEY = 'announcement_banner_dismissed';

export const AnnouncementBanner: React.FC = () => {
  const navigate = useNavigate();
  const { latestUnreadAnnouncement, fetchUnreadAnnouncements, markAnnouncementRead } = useAnnouncementStore();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    fetchUnreadAnnouncements();
    const interval = setInterval(() => fetchUnreadAnnouncements(), 120000);
    return () => clearInterval(interval);
  }, [fetchUnreadAnnouncements]);

  // Only show banner for urgent announcements
  if (!latestUnreadAnnouncement || dismissed || latestUnreadAnnouncement.priority !== 'urgent') return null;

  const dismissedIds: string[] = (() => {
    try {
      return JSON.parse(localStorage.getItem(BANNER_DISMISSED_KEY) || '[]');
    } catch {
      return [];
    }
  })();

  if (dismissedIds.includes(latestUnreadAnnouncement.id)) return null;

  const handleDismiss = () => {
    const updated = [...dismissedIds, latestUnreadAnnouncement.id].slice(-20);
    localStorage.setItem(BANNER_DISMISSED_KEY, JSON.stringify(updated));
    markAnnouncementRead(latestUnreadAnnouncement.id);
    setDismissed(true);
  };

  const handleViewDetail = () => {
    navigate('/notifications');
    handleDismiss();
  };

  return (
    <div className="border-b bg-red-50 border-red-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0 flex-1">
            <span className="shrink-0 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-700">
              紧急
            </span>
            <span className="text-sm font-medium text-gray-900 truncate">
              {latestUnreadAnnouncement.title}
            </span>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <button
              onClick={handleViewDetail}
              className="text-sm text-blue-600 hover:text-blue-700 font-medium"
            >
              查看详情
            </button>
            <button
              onClick={handleDismiss}
              className="p-1 text-gray-400 hover:text-gray-600 transition-colors"
              title="关闭"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
